// Globals
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import { PickerProps } from 'antd/lib/date-picker/generatePicker';
import 'antd/lib/date-picker/style/index';

// Components
import { StyledDatePicker } from './DatePickerStyles';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

type IDatePicker = PickerProps;

const DatePicker = ({ value, ...props }: IDatePicker) => (
  <StyledDatePicker {...props} value={value} placeholder={props.placeholder || ''} onFocus={(e) => e.target.blur()} />
);

export default DatePicker;
